/**
 * v0.3 (S-16) カスタムロール関連の新規エラーコード日本語文言マッピング。
 * 設計: docs/design/v03-custom-roles.md §4.6
 */
import type { ApiClientError } from './api';

type ErrorLabel = { message: string; action: string };

const PERMISSION_ERROR_LABELS: Record<string, ErrorLabel> = {
  SELF_PRIVILEGE_ESCALATION: { message: '自分に割り当てられているロールに、まだ持っていない権限を付与することはできません', action: '別の管理者に依頼してください' },
  SYSTEM_ROLE_PROTECTED: { message: 'システム標準ロールは編集・削除できません', action: 'カスタムロールを新規作成してください' },
  ROLE_NOT_FOUND: { message: '対象のロールが見つかりません', action: 'すでに削除されている可能性があります。一覧を再読み込みしてください' },
  OUT_OF_SCOPE: { message: 'この操作の対象は、あなたのアクセス範囲外です', action: 'アクセスできる店舗/ブランドを確認してください' },
  CROSS_TENANT_ROLE: { message: '他テナントのデータにはアクセスできません', action: '(通常発生しない、発生時はサポートへ)' },
  CROSS_TENANT_NODE: { message: '他テナントのデータにはアクセスできません', action: '(通常発生しない、発生時はサポートへ)' },
  CROSS_TENANT_USER: { message: '他テナントのデータにはアクセスできません', action: '(通常発生しない、発生時はサポートへ)' },
  INVALID_NODE_SCOPE: { message: 'ノード指定型の権限には、少なくとも1つのノードを選択してください', action: 'スコープ選択でノードを追加してください' },
  ROLE_IN_USE: { message: 'このロールは1名以上のユーザーに割当中のため削除できません', action: '対象ユーザーからロールを外してから再度お試しください' },
  UNKNOWN_PERMISSION: { message: '不明な権限が指定されました', action: '画面を再読み込みして再度お試しください' },
  PERMISSION_DENIED: { message: 'この操作を行う権限がありません', action: '管理者に依頼してください' },
};

/** ApiClientError からユーザー向け表示文言を組み立てる。マッピング対象のcodeなら
 *  「メッセージ + 次のアクション」、それ以外はバックエンドの生メッセージ (既に日本語・具体的) を返す。 */
export const describeApiError = (err: ApiClientError): string => {
  const label = PERMISSION_ERROR_LABELS[err.code];
  if (!label) return err.message;
  return `${label.message}（${label.action}）`;
};
